<ng-template #content let-modal>
	<div class="spinner-border d-flex align-self-center" style="width: 3rem; height: 3rem;" role="status">
		<span class="sr-only">Loading...</span>
	</div>
</ng-template>

